import {
  techRadarApiRef,
  TechRadarApi,
} from '@backstage-community/plugin-tech-radar';
import {
  TechRadarLoaderResponse,
  RadarEntrySnapshot,
} from '@backstage-community/plugin-tech-radar-common';
import {
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';

class SaltSquareTechRadarApi implements TechRadarApi {
  constructor(
    private readonly discoveryApi: DiscoveryApi,
    private readonly fetchApi: FetchApi,
  ) {}

  async load(_id: string | undefined): Promise<TechRadarLoaderResponse> {
    const backendBase = await this.discoveryApi.getBaseUrl('tech-radar-data');
    const res = await this.fetchApi.fetch(`${backendBase}/data/radar.json`);
    if (!res.ok) {
      throw new Error(
        `Tech Radar load failed: ${res.status} ${res.statusText}`,
      );
    }
    const raw = (await res.json()) as TechRadarLoaderResponse;
    // The Tech Radar plugin expects timeline `date` to be a Date instance;
    // it arrives as an ISO string over the wire.
    return {
      ...raw,
      entries: raw.entries.map(entry => ({
        ...entry,
        timeline: entry.timeline.map(
          (snapshot): RadarEntrySnapshot => ({
            ...snapshot,
            date: new Date(snapshot.date as unknown as string),
          }),
        ),
      })),
    };
  }
}

export const saltSquareTechRadarApiFactory = createApiFactory({
  api: techRadarApiRef,
  deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
  factory: ({ discoveryApi, fetchApi }) =>
    new SaltSquareTechRadarApi(discoveryApi, fetchApi),
});
